module.exports = __webpack_public_path__ + "static/media/image6.d2b4e6e8.png";